import React, { ReactElement, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { AiOutlineClose } from 'react-icons/ai';

import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../store/store';
import { AuthState, useAuth } from '../../auth/AuthProvider';
import { showRegisterModal } from '../register.slice';
import appleStoreImage from '../../../assets/png/everylive-QRcode-Apple-store.png';
import googlePlayImage from '../../../assets/png/everylive-QRcode-google-play.png';

import './RegisterModal.scss';
import { appStoreUrl, playStoreUrl } from '../../../common/config/const';

export const RegisterModal = (): ReactElement => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const state = useSelector((state: AppState) => state.registerModalState);

  const { logOut, isAuthenticated, isRegistering } = useAuth() as AuthState;

  const close = () => {
    logOut();
    dispatch(showRegisterModal({ visible: false }));
  };

  useEffect((): void => {
    // show login modal when user not login

    if (!isAuthenticated && isRegistering) {
      dispatch(
        showRegisterModal({
          visible: true,
        }),
      );
    }
  }, [isAuthenticated, isRegistering]);

  if (!state.visible) {
    return <></>;
  }

  return (
    <div className="register-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content register-modal__content">
          <div className="login-modal__close-btn" onClick={close}>
            <AiOutlineClose />
          </div>
          <h2 className="register-modal__title">{t('RegisterNewUser')}</h2>
          <div>
            <h6>
              ※ Webクライアントでは新規会員登録ができません。
              アプリからご登録ください。
            </h6>
            <div>
              <div className="app-store-banner">
                <div className="app-store-title"> • App Store : </div>
                <div className="app-stor-qr-code">
                  <a
                    href={appStoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{ width: '70%' }}
                      src={appleStoreImage}
                      alt="appleStoreImage"
                    />
                  </a>
                </div>
              </div>
              <div className="app-store-banner">
                <div className="app-store-title"> • Google Play : </div>
                <div className="app-stor-qr-code">
                  <a
                    href={playStoreUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      style={{ width: '70%' }}
                      src={googlePlayImage}
                      alt="appleStoreImage"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
